"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeExtension = exports.codeOptions = void 0;
const extension_code_1 = __importDefault(require("@tiptap/extension-code"));
const state_1 = require("@tiptap/pm/state");
const prosemirror_codemark_1 = __importDefault(require("prosemirror-codemark"));
exports.codeOptions = {
    HTMLAttributes: {
        class: 'proseCode'
    }
};
/**
 * Note: do not forget to include css import for UI use of this extension.
 * import 'prosemirror-codemark/dist/codemark.css'
 */
exports.CodeExtension = extension_code_1.default.extend({
    addProseMirrorPlugins() {
        return [
            ...(0, prosemirror_codemark_1.default)({ markType: this.editor.schema.marks.code }),
            new state_1.Plugin({
                key: new state_1.PluginKey('code-consecutive-backticks'),
                props: {
                    // Typing a character inside of two backticks will wrap the character
                    // in an inline code mark.
                    handleTextInput: (view, from, to, text) => {
                        const { state } = view;
                        // Prevent access out of document bounds
                        if (from === 0 || to === state.doc.nodeSize - 1 || text === '`') {
                            return false;
                        }
                        if (from === to &&
                            state.doc.textBetween(from - 1, from) === '`' &&
                            state.doc.textBetween(to, to + 1) === '`') {
                            const start = from - 1;
                            const end = to + 1;
                            view.dispatch(state.tr
                                .delete(start, end)
                                .insertText(text, start)
                                .addMark(start, start + text.length, state.schema.marks.code.create()));
                            return true;
                        }
                        return false;
                    },
                    // Pasting a character inside of two backticks will wrap the character
                    // in an inline code mark.
                    handlePaste: (view, _event, slice) => {
                        const { state } = view;
                        const { from, to } = state.selection;
                        // Prevent access out of document bounds
                        if (from === 0 || to === state.doc.nodeSize - 1) {
                            return false;
                        }
                        const start = from - 1;
                        const end = to + 1;
                        if (from === to && state.doc.textBetween(start, from) === '`' && state.doc.textBetween(to, end) === '`') {
                            view.dispatch(state.tr
                                .replaceRange(start, end, slice)
                                .addMark(start, start + slice.size, state.schema.marks.code.create()));
                            return true;
                        }
                        return false;
                    }
                }
            })
        ];
    }
});
//# sourceMappingURL=code.js.map